function Home() {
  return (
    <>
      <h1 className="text-primary">Content</h1>
    </>
  );
}

export default Home;
